module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fmtitle"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "leaf1"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "9",
      "src": "images/leaf.jpg",
      "width": "28"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/05_Illustrations"
    }
  }, [_vm._v("List of Illustrations")])])]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/06_Maps"
    }
  }, [_vm._v("List of Maps")])])]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/07_Preface"
    }
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/08_Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "content1"
  }, [_c('a', {
    attrs: {
      "href": "#/09_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "content1"
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#/10_Part01"
    }
  }, [_vm._v("Part One: Scotsman")])])]), _vm._v(" "), _c('table', {
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "95%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/11_Chapter01"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/11_Chapter01"
    }
  }, [_vm._v("Eskdale Childhood, 1769–1782")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "content1"
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#/12_Part02"
    }
  }, [_vm._v("Part Two: Soldier")])])]), _vm._v(" "), _c('table', {
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "95%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/13_Chapter02"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/13_Chapter02"
    }
  }, [_vm._v("The Madras Army, 1783–1794")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/14_Chapter03"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/14_Chapter03"
    }
  }, [_vm._v("Britain, The Cape and Madras, 1794–1798")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/15_Chapter04"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/15_Chapter04"
    }
  }, [_vm._v("Hyderabad, 1798")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/16_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/16_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mysore, 1799")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "content1"
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/17_Part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three: Diplomat")])])]), _vm._v(" "), _c('table', {
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "95%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/18_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/18_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Envoy to Persia, 1799")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/19_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/19_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The First Persian Mission, 1800–1801")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/20_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/20_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Private Secretary – ‘Send Malcolm’, 1801–1802")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/21_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/21_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Private Secretary – Scandal in Hyderabad")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/22_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/22_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Private Secretary – Lord Wellesley’s Factotum, 1801–1802")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/23_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/23_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Private Secretary – The College of Fort William, 1801–1802")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/24_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/24_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mahrattas – Peace and War, 1803")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/25_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mahrattas – Scindiah, 1804")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/26_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/26_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The End of the Wellesley Era, 1805")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/27_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/27_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mahrattas, 1805–1807")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/28_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/28_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mysore – Love and Marriage, 1807–1808")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/29_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/29_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Second Persian Mission, 1808")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/30_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/30_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mutiny at Masulipatam, 1809")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/31_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/31_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Third Persian Mission, 1810")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/32_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/32_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baghdad and Back, 1810")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/33_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/33_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Persian Postscript, 1811–1833")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "content1"
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/34_part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Four: Author")])])]), _vm._v(" "), _c('table', {
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "95%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/35_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/35_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bombay, 1811")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/36_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/36_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("England – Family, Career and the Literary World, 1812–1816")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "content1"
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/37_part05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Five: Proconsul")])])]), _vm._v(" "), _c('table', {
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "95%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/38_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/38_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("India – Shuttle Diplomacy, 1817")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/39_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/39_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("India – War, 1817–1818")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/40_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/40_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("India – Surrender of the Peshwah, 1818")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/41_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/41_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("India – Ruler of Central India, 1818–1821")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "content1"
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/42_part06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Six: Ideologue")])])]), _vm._v(" "), _c('table', {
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "95%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/43_Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/43_Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Civil Governance – Three Scots in Western India")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/44_Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/44_Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("England – Country Gentleman, 1822–1827")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/45_Chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/45_Chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Governor of Bombay – Events, 1827–1830")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/46_Chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/46_Chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Governor of Bombay – Quarrel with the Judges")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/47_Chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/47_Chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("England – Last Days, 1831–1833")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "content1"
  }, [_c('span', {
    attrs: {
      "href": "#/48_Postcript",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Postscript")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "content1"
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/49_Appendices",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendices")])])]), _vm._v(" "), _c('table', {
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "95%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/50_Appendices01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(".")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/50_Appendices01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("British Government and EIC Office Holders between 1783 and 1833")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/51_Appendices02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(".")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/51_Appendices02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Horses – ‘The Khan’")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/52_Appendices03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(".")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/52_Appendices03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Estimated Population of British India, c.1825–1830")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/53_Appendices04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(".")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/53_Appendices04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finances of Bombay Territories, 1827–1832")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "content1"
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/54_Glossary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary, Terminology and Spelling")])])]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_c('span', {
    attrs: {
      "href": "#/54_Glossary#gloss1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary of Indian, Anglo-Indian and Persian Words and Phrases")])]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_c('span', {
    attrs: {
      "href": "#/55_Note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Note on Terminology")])]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_c('span', {
    attrs: {
      "href": "#/55_Note#note1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Note on Spelling")])]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_c('span', {
    attrs: {
      "href": "#/55_Note#note2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spelling of Indian and Persian Names")])]), _vm._v(" "), _c('p', {
    staticClass: "content1"
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/56_Familytree",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Family Tree")])])]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_c('span', {
    attrs: {
      "href": "#/56_Familytree#malcolm",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Malcolm of Burnfoot Family")])]), _vm._v(" "), _c('p', {
    staticClass: "content1"
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/57_Abbreviations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "content1"
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/58_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "content1"
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/59_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "content1"
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/60_Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of People")])])]), _vm._v(" "), _c('p', {
    staticClass: "content1"
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/61_Generalindex",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("General Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "content1"
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/62_Plates",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate Section")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d6d5693","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_Contents.vue
// module id = 66
// module chunks = 0